import {Brick, registerBrick, ErrorFlow} from 'olympe';

/**
 * Extract values from the JSON object
 */
export default class GetFromJsonObject extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {string} path
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [source, path], [setResult, setErrorFlow]) {
        if (source.hasOwnProperty(path)) {
            setResult(source[path]);
        } else {
            setErrorFlow(ErrorFlow.create(
                `Cannot extract value: ${error}`,
                1,
            ));
        }
    }
}

registerBrick('0187fb5147c9d4770f79', GetFromJsonObject);